import { Col, Row } from "react-bootstrap";
import { useRef, useState } from "react";
import { handleClickColor } from "../../Common/Util";

export function TransitPlanetInInterval ({transitIntervalData,date,startTime,endTime,setDate,setStartTime,setEndTime,handleCalculate}) {
  const [group, setGroup] = useState("0");
  const tableReference = useRef();

  const handleDateChange = (event,setValue) => {
    const value = event.target.value;
    if(value===null || value===undefined || value==='' || value.length<10) {
    } else {
      setValue(value);
    }
  }

  const handleTimeChange = (event,setValue) => {
    const value = event.target.value;
    if(value===null || value===undefined || value==='' ) {
    } else {
      setValue(value);
    }
  }

  const handleRadioChange = (event) => {
    setTimeout(() => {
        setGroup(event.target.value);
    }, 100);
  };

  const handleUp = (val) => {
    clearTableColor();
    setStartTime(val);
    handleCalculate(val,endTime);
  };

  const handleDown = (val) => {
    clearTableColor();
    setEndTime(val);
    handleCalculate(startTime,val);
  };

  const clearTableColor = ()=>{
    const tableRows = tableReference.current.getElementsByTagName('tr');
    for (let i = 0; i < tableRows.length; i++) {
      const row = tableRows[i];
      const tableCells = row.getElementsByTagName('td');
      //alert(i+" "+tableCells.length);
      for (let j = 0; j < tableCells.length; j++) {
        const cell = tableCells[j];
        cell.style={backgroundcolor:"white"}
        console.log('Cell content:', cell.innerHTML);
      }
    }
  }

  return(
    <>
    <Row id="transitcuspalininterval" className="m-0 p-0">
      <Col xs={12} xl={3} className="m-0 p-0">
        <table class="m-0 p-0 w-100">
          <caption class="m-0 p-0"><h4 class="m-0 p-0 ps-1">Planet in Interval</h4></caption>
        </table>
      </Col>
      <Col xs={12} xl={6} className="m-0 p-0 text-center">
        <Row id="transitcuspal" className="m-0 p-0">
          <Col xs={12} lg={3} className="m-0 p-1 fw-bold">
            <input type="date" maxlength="10" class="form-control" oninput="if(this.value.length > 10) this.value = this.value.replace(/\d{5,}/, match => match.substr(0, 4));" max="2999-12-31" id="datename" name="datename" value={date} onChange={(event)=>handleDateChange(event,setDate)} title='Note: Press 2 to enter 02, Press 225 to enter 25' style={{ 'letterSpacing':'0.2em' }}/>
          </Col>
          <Col xs={12} lg={7} className="m-0 p-1 fw-bold">
            <table className="m-0 p-0 ps-1 pe-1 w-100 ">
              <tr>
                <td className="m-0 p-0 ps-1 pe-1 text-start">Start</td> 
                <td className="m-0 p-0 ps-1 pe-1 text-start"><input type="time" step="1" maxlength="10" class="form-control" id="startTime" name="startTime" value={startTime} onChange={(event)=>handleTimeChange(event,setStartTime)} title='Note: Press 4 to enter 04, Press 446 to enter 46' style={{ 'letterSpacing':'0.3em' }} /></td> 
                <td className="m-0 p-0 ps-1 pe-1 text-start">End</td> 
                <td className="m-0 p-0 ps-1 pe-1 text-start"><input type="time" step="1" maxlength="10" class="form-control" id="endTime" name="endTime" value={endTime} onChange={(event)=>handleTimeChange(event,setEndTime)} title='Note: Press 4 to enter 04, Press 446 to enter 46' style={{ 'letterSpacing':'0.3em' }} /></td> 
              </tr>
            </table>
          </Col>
          <Col xs={12} lg={2} className="m-0 p-1">
            <button type="button" class="btn btn-outline-primary" onClick={(event)=>handleCalculate(startTime,endTime)}>Calculate</button>
          </Col>
        </Row>  
      </Col>
      <Col xs={12} xl={3} className="m-0 p-0">
      <table class="m-0 p-0 ps-1 pe-1 w-100 h-100 align-middle">
        <tr class="m-0 p-0">
          <td class="m-0 p-0 text-start">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="group" id="group0" value="0" checked={group==="0"?true:false} onChange={(e) => handleRadioChange(e)}/>
              <label class="form-check-label" for="group0">No Group</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="group" id="group1" value="1" checked={group==="1"?true:false} onChange={(e) => handleRadioChange(e)}/>
              <label class="form-check-label" for="group1">Sub Lord</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="group" id="group2" value="2" checked={group==="2"?true:false} onChange={(e) => handleRadioChange(e)}/>
              <label class="form-check-label" for="group2">Star Lord</label>
            </div>
          </td>
        </tr>
      </table>
      </Col>
    </Row>      

    <Row id="transitcuspalininterval1" className="m-0 p-0 text-center">
      <Col xs={12} className="m-0 p-1">
      {transitIntervalData===null||transitIntervalData===undefined||transitIntervalData.PlanetNameList===null||transitIntervalData.planetNameList===undefined?<></>:
      <table ref={tableReference} class="m-0 p-0 table table-bordered border-primary table-hover text-center w-100">
        <thead class="m-0 p-0">
          <tr class="m-0 p-0">
            <th class="m-0 p-1">Date</th>
            {transitIntervalData.planetNameList.map((name,index) => (
              index<9?<th class="m-0 p-1" onClick={handleClickColor}>{name}</th>:<></>
            ))}
          </tr>
        </thead>
        <tbody class="m-0 p-0">
          {transitIntervalData.dateList.map((dateName,dateIndex) => (
          <tr class="m-0 p-0">
            <th class="m-0 p-1"><button type="button" class="btn btn-outline-secondary border-0 rounded-circle p-1 ps-2 pe-2" onClick={()=>handleUp(dateName)}>&#129129;</button> {dateName} <button type="button" class="btn btn-outline-secondary border-0 rounded-circle p-1 ps-2 pe-2" onClick={()=>handleDown(dateName)}>&#129131;</button></th>
            {transitIntervalData.planetList[dateIndex].map((name,index) => ( 
              index>=9?<></>
              :group==='2'?<td onClick={handleClickColor} class={"m-0 p-1"+(transitIntervalData.planetStarSpanList[dateIndex][index]===0 || dateIndex===0?"":" bg-danger")+(transitIntervalData.planetRetroList[dateIndex][index]===null?"":" text-primary")}>{name}</td>
              :group==='1'?<td onClick={handleClickColor} class={"m-0 p-1"+(transitIntervalData.planetSpanList[dateIndex][index]===0 || dateIndex===0?"":" bg-danger")+(transitIntervalData.planetRetroList[dateIndex][index]===null?"":" text-primary")}>{name}</td>
              :<td onClick={handleClickColor} class={"m-0 p-1"+(transitIntervalData.planetRetroList[dateIndex][index]===null?"":" text-primary")}>{name}</td>
            ))}
          </tr>
          ))}
        </tbody>
      </table>
      }
      </Col>
    </Row>      
    </>
  );
}

